module.exports = __webpack_public_path__ + "images/psp/hero/self-hero.webp";